import { InfoAgentsAction } from "Components/InfoAgents/Redux/actions";

export interface IInfoAgents {
  isFetchingAgents: boolean;
  isFetchingContent: boolean;
  isFetchAgentsFailed: boolean;
  isFetchContentFailed: boolean;
  agents: Julius.Website.AgentViewModel[];
  content: Julius.Website.AgentsPageViewModel;
};

const initialInfoAgents: IInfoAgents = {
  isFetchingAgents: false,
  isFetchingContent: false,
  isFetchAgentsFailed: false,
  isFetchContentFailed: false,
  agents: null,
  content: null,
};

function infoAgents(
  state: IInfoAgents = initialInfoAgents, 
  action: InfoAgentsAction,
  ): IInfoAgents {
    
  switch (action.type) {
    case 'SET_IS_FETCHING_AGENTS':
      return {
        ...state,
        isFetchingAgents: true,
        isFetchAgentsFailed: false,
      };

    case 'SET_IS_FETCHING_AGENTS_CONTENT':
      return {
        ...state,
        isFetchingContent: true,
        isFetchContentFailed: false,
      };

    case 'SET_FETCH_AGENTS_FAILED':
      return {
        ...state,
        isFetchingAgents: false,
        isFetchAgentsFailed: true,
      };

    case 'SET_FETCH_AGENTS_CONTENT_FAILED':
      return {
        ...state,
        isFetchingContent: false,
        isFetchContentFailed: true,
      };

    case 'SET_AGENTS':
      return {
        ...state,
        agents: action.agents,
        isFetchingAgents: false,
        isFetchAgentsFailed: false,
      };

    case 'SET_AGENTS_CONTENT':
      return {
        ...state,
        content: action.content,
        isFetchingContent: false,
        isFetchContentFailed: false,
      };

    default:
      return state;
  }
}

export default infoAgents;


// WEBPACK FOOTER //
// ./src/components/InfoAgents/Redux/reducer.tsx